import { consola } from 'consola'
import { useSessionManager } from '~/entities/auth'
import { useTokenRefreshV2, requiresAuth } from '~/features/auth/model'

const logger = consola.withTag('auth-middleware')

export const runAuthMiddleware = async (to: { path: string }, from: { path: string }) => {
  if (!process.client) return

  const isPaymentResultPage = to.path === '/success' || to.path === '/fail'
  const isProcessingPayment = sessionStorage.getItem('payment_processing') === 'true'
  if (isPaymentResultPage && isProcessingPayment) return

  const sessionManager = useSessionManager()
  const tokenRefreshV2 = useTokenRefreshV2()

  let hasAccessToken = !!sessionManager.authAccessToken.value
  let hasSessionId = !!sessionManager.authSessionId.value
  if (!hasAccessToken || !hasSessionId) {
    const restored = await sessionManager.restoreSessionFromStorage()
    if (restored) {
      hasAccessToken = !!sessionManager.authAccessToken.value
      hasSessionId = !!sessionManager.authSessionId.value
    }
  }

  if (!hasAccessToken && hasSessionId) {
    logger.warn('Access token отсутствует, обновляем через V2')
    await tokenRefreshV2.refreshToken()
  }

  if (requiresAuth(to.path)) {
    const authStore = useAuthStore()
    if (!authStore.isLoggedIn) {
      logger.warn('🚫 Доступ запрещен', { path: to.path, from: from.path })
      return navigateTo('/404', { replace: true })
    }
  }
}
